import { render } from "./EventHome.vue?vue&type=template&id=f94f59de"
import script from "./EventHome.vue?vue&type=script&lang=js"
export * from "./EventHome.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__